import { ListItemButton, ListItemIcon, Typography } from "@mui/material";
import React, { ReactNode } from "react";

export interface MenuPositionProps {
  text: string;
  children?: ReactNode;
  onClick?: () => void;
  onMouseEnter?: () => void;
  active?: boolean;
  disabled?: boolean;
  baseColor?: string;
  activeColor?: string;
  backgroundColor?: string;
}

export const MenuPosition: React.FC<MenuPositionProps> = ({
  active = false,
  text,
  children,
  onClick,
  onMouseEnter,
  baseColor = "var(--soft-black-gray-scale-100-white)",
  backgroundColor = "var(--green-grey-scale-cold-tones-cold-tones-800)",
  activeColor = "pink",
  disabled = false,
}) => (
  <ListItemButton
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    disabled={disabled}
    sx={{
      minHeight: 48,
      justifyContent: "center",
      px: 2.5,
      background: backgroundColor,
    }}
  >
    <ListItemIcon
      sx={[
        {
          minWidth: 0,
          width: "100%",
          textAlign: "center",
          mr: "auto",
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        },
        active
          ? {
              color: activeColor,
            }
          : {
              color: baseColor,
            },
      ]}
    >
      {children}
      <Typography
        sx={[
          {
            mt: 1,
            fontSize: "8px",
            lineHeight: "12px",
            textTransform: "uppercase",
          },
          active
            ? {
                color: activeColor,
              }
            : {
                color: baseColor,
              },
        ]}
      >
        {text}
      </Typography>
    </ListItemIcon>
  </ListItemButton>
);

export default MenuPosition;
